<div class="row no-gutters">
    <div class="col-md-12 col-lg-6">
        <div class="row no-gutters">
            <div class="col-sm-10">
                <div class="smp-title-thin-border">{{ 'user_management.title.assignment' | translate }} </div>

                <mat-form-field class="full-width"
                                *ngIf="assignments">
                    <mat-select id="{{idPrefix}}client_user.assignment"
                                [(ngModel)]="user.member_structure"
                                [compareWith]="compareAssignments"
                                [disabled]="disabled">
                        <mat-option *ngFor="let item of assignments.items; let idx = index"
                                    id="{{idPrefix}}client_user.assignment.option_{{idx}}"
                                    [value]="item">
                            {{ item.display_name | translate }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-2">

            </div>
        </div>
    </div>
</div>
